<template lang="html">
  <div>
      <b-container class="p-0">
        <b-form @submit="add_tolist" inline>
          <b-row no-gutters  class="w-100">
            <b-col>
              <label>Tehtävä</label>
              <b-form-input v-model = "tehtava" class="w-100" type="text" placeholder="Lisää tehtävä"/>
            </b-col>
            <b-col md="auto">
              <label>Tärkeys</label>
              <b-form-spinbutton v-model = "spinprio" min = "0" max = "5" placeholder="-" inline></b-form-spinbutton>
            </b-col>
            <b-col md="auto">
              <label>Deadline</label>
              <b-form-input
                v-model = "D_day"
                type="date"
                />
            </b-col>
          </b-row>
          <b-row no-gutters  class="w-100">
            <b-button size="sm" type="submit"  variant="primary" class="m-1" href="">
                Lisää tehtävä
            </b-button>
          </b-row>
        </b-form>
      </b-container>
  </div>
</template>

<script>
import uuid from 'uuid/v4';
import moment from 'moment';

export default {
  name:"Add_item",
  data() {
    return {
      tehtava: '',
      spinprio: 0,
      D_day: '--/--/----',
    }
  },
  methods: {
    add_tolist(e) {
      e.preventDefault();
      if (this.tehtava.length > 0){
        if (moment(this.D_day, 'YYYY-MM-DD').isValid()){
          this.D_day = moment(this.D_day).format('DD/MM/YYYY');
        }
        else{
          this.D_day = "--/--/----";
        }
        const new_item = {
          title: this.tehtava,
          completed: false,
          priotited: this.spinprio,
          deadline:  this.D_day,
          id: uuid(),
          duration:0,
        }
        this.$emit("add_tolist", new_item);
        this.tehtava = "";
        this.spinprio = 0;
        this.D_day = '--/--/----';

      }
    },
    // format(value, event){
    //   return moment(value).format('YYYY-MM-DD')
    // }

  }

}
</script>

<style lang="css" scoped>
label{
  font-weight: bold;
}
</style>
